import React from 'react';
import Link from 'next/link';
import Modal from '@common/modal';
import { useJD } from '@repository/position/usePosition';
import { V2Route } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './modals.module.scss';

const cx = classnames.bind(styles);

interface ApplyExceedModalProps {
  positionSn: number;
  visible: boolean;
  onClose: () => void;
}

const ApplyExceedModal = ({ positionSn, visible, onClose }: ApplyExceedModalProps) => {
  const { data: positionDetail } = useJD(positionSn);

  if (!positionDetail) return null;

  const {
    additionalInfo: { challenge },
  } = positionDetail;

  if (!challenge) return null;

  return (
    <Modal visible={visible} dimmed={false}>
      <div className={cx('layer')}>
        <em className={cx('title')}>지원 가능한 횟수를 초과하였습니다.</em>

        <p className={cx('desc')}>
          복수 지원이 제한된 포지션입니다.
          <br />
          지원 정책은 관련 채용이벤트를 확인해 주세요.
          <br />
          <Link href={V2Route.getChallengePage(challenge.challengeSn)} legacyBehavior>
            {challenge.challengeName}
          </Link>
        </p>

        <div className={cx('btnArea')}>
          <a className={cx('btn', 'confirm')} role="button" onClick={onClose}>
            확인
          </a>
        </div>

        <a className={cx('btnClose')} role="button" onClick={onClose}>
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </Modal>
  );
};

export default ApplyExceedModal;
